// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title-bg[data-v-f8ea34ca] {\n  background: repeating-linear-gradient(\n    45deg,\n    rgb(124, 0, 0),\n    rgba(124, 0, 0) 20px,\n    rgba(30, 30, 30) 20px,\n    rgba(30, 30, 30) 40px\n  );\n}\n.die-hover[data-v-f8ea34ca] {\n  opacity: 0.75;\n  transform: all 0.3s;\n}\n.die-hover[data-v-f8ea34ca]:hover {\n  opacity: 1;\n  background-color: #e3f2fd;\n}\n", ""]);
// Exports
module.exports = exports;
